import AdminDateChoice from "routes/admin/datePicker/AdminDateChoice";
import style from "./TableSearchCard.module.css";
import InventoryManagementSearch from "./card/InventoryManagementSearch";
import ProductInquirySearch from "./card/ProductInquirySearch";
import OrderInquirySearch from "./card/OrderInquirySearch";
import OutOfStockManagementSearch from "./card/OutOfStockManagementSearch";
import NewOrderInquirySearch from "./card/NewOrderInquirySearch";
import PromotionInquirySearch from "./card/PromotionInquirySearch";
import TaxInquirySearch from "./card/TaxInquirySearch";
import CustomerInquirySearch from "./card/CustomerInquirySearch";
import CustomerRegistInquirySearch from "./card/CustomerRegistInquirySearch";
import ArticleInquirySearch from "./card/ArticleInquirySearch";
import StatisticInquirySearch from "./card/StatisticInquirySearch";

function TableSearchCard(props) {
  const { index, callback, reset, setReset, research, keyword } = props;

  return (
    <div className={style.card}>
      {
        {
          0: (
            <InventoryManagementSearch
              callback={callback}
              dateTitle={"상품 등록일"}
            />
          ),
          1: (
            <ProductInquirySearch
              key={keyword}
              callback={callback}
              reset={reset}
              setReset={setReset}
              research={research}
            />
          ),
          2: <OrderInquirySearch callback={callback} />,
          3: <OutOfStockManagementSearch callback={callback} />,
          4: (
            <NewOrderInquirySearch
              key={keyword}
              callback={callback}
              reset={reset}
              setReset={setReset}
              research={research}
            />
          ),
          5: <PromotionInquirySearch callback={callback} />,
          6: (
            <TaxInquirySearch
              key={keyword}
              callback={callback}
              reset={reset}
              setReset={setReset}
              research={research}
            />
          ),
          7: (
            <CustomerInquirySearch
              key={keyword}
              callback={callback}
              reset={reset}
              setReset={setReset}
              research={research}
            />
          ),
          8: (
            <CustomerRegistInquirySearch
              key={keyword}
              callback={callback}
              reset={reset}
              setReset={setReset}
              research={research}
            />
          ),
          9: (
            <ArticleInquirySearch
              key={keyword}
              callback={callback}
              reset={reset}
              setReset={setReset}
              research={research}
            />
          ),
          10: (
            <StatisticInquirySearch
              key={keyword}
              callback={callback}
              reset={reset}
              setReset={setReset}
              research={research}
            />
          ),
        }[index]
      }
    </div>
  );
}

export default TableSearchCard;
